<template>
    <body style="background-color:white">        
        <app-toolbar2></app-toolbar2>      
            <v-layout row wrap style="height:100vh;width:100vw" class="">
                <v-flex xs12 style="height:100vh;width:100vw">
                    <v-carousel hide-delimiters style="height:100vh;width:100vw" interval="10000">
                        <v-carousel-item v-for="item in images" :key="item.id" :src="item.imageUrl">
                            <div class="title">
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
                                    <v-card flat class="transparent white--text">
                                        <v-card-title 
                                        style="font-size:50px;border:solid 3px white" 
                                        class="white--text">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="animated">
                                                    <span>Track<span style="color:blue">Me</span></span>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                        </v-card-title>
                                        <v-card-text 
                                        style="font-size:4vh;">
                                            {{item.title}}
                                        </v-card-text>
                                    </v-card>
                                    </v-flex>
                                </v-layout>
                            </div>                            
                        </v-carousel-item>
                    </v-carousel>
                </v-flex>
            </v-layout>                

        <v-layout row wrap>      
            <v-container fluid>
                <section id="about">
                <app-about></app-about>
                </section>
            </v-container>
        </v-layout>
        
        <v-layout row wrap>
            <v-container fluid id="services">
                <app-services></app-services>
            </v-container>
        </v-layout>

        <v-container fluid id="service2">
            <app-service2></app-service2>
        </v-container>

        <v-container fluid id="contacts">
            <app-contacts></app-contacts>
        </v-container>
       
    </body>
</template>

<script>
import About from '@/components/MainPage/about'
import Services from '@/components/MainPage/services'
import Toolbar2 from '@/components/toolbar2'
import Contacts from '@/components/MainPage/contacts'
import Service2 from '@/components/MainPage/service2'
export default {
    data(){
        return {
            images: [
                { imageUrl:'static/bus14e5.jpg' , id:'img_1' , title: 'View timetable and number of available seats',subtitle:'Passengers can visit our website and select the destination they want. Then they will receive details about relevant bus such as the available number of seats etc.'},
                { imageUrl:'static/mgt.jpg' , id:'img_2' , title: 'Owners can manage and view their vehicle information',subtitle:''},
                { imageUrl:'static/dev3.jpg' , id:'img_3' , title: 'We provide a web application and a mobile app'},
                
                
            ],
            
        }
    },
    components:{
   
    'app-about': About,
    'app-services': Services,
    'app-toolbar2': Toolbar2,
    'app-contacts':Contacts,
    'app-service2': Service2,
  },

};

/* $('.js-anchor-link').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
  }
}); */



</script>

<style scoped>
    .title{
        position: absolute;
        bottom: 0;
        left:0;
        right: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        background-size: cover;
        padding-left:0;
        padding-top: 35vh;
    }



@keyframes animation {
  from {
    letter-spacing: 32px;
  }
  to {
    letter-spacing: 0;
  }
}

.animated {
  animation: animation 5s ease;
}

    
</style>





// WEBPACK FOOTER //
// src/components/main.vue